/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-10-26 09:40:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-25 17:04:22
 */
import axios from 'axios';
import { ServerPath } from '@/config/serverPath';

// 登录验证
export async function login(loginInfo) {
    var resp = await axios.post(`${ServerPath}/api/login_check/index.html`, loginInfo, {
        withCredentials: true // 可以携带cookie
    });

    // 保存token
    var token = resp.headers.authorization;
    if (token) {
        localStorage.setItem('token', token);
        return resp.data;
    }
    return resp;
}

// 验证登录状态
export async function check_login() {
    var token = localStorage.getItem('token');
    var resp = null;
    if (!token) {
        return 'login_error';
    } else {
        await axios({
            method: 'POST',
            url: `${ServerPath}/api/api/index.html`,
            headers: {
                authorization: `bearer ${token}`
            }
        }).then(res => {
            resp = res;
        }).catch(req => {
            console.log(req);
        });
    }
    return resp.data;
}

// 注销
export function loginOut() {
    localStorage.removeItem('token');
    location.href = './Login';
}

/**
 * @name: 修改会员密码
 * @msg:  无
 * @param {*} pwd_info{old_pwd,new_pwd,new_pwd_again}
 * @return {*}
 */
export async function change_pwd(pwd_info) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'POST',
        url: `${ServerPath}/api/api/change_password.html`,
        headers: {
            authorization: `bearer ${token}`
        },
        data: {
            pwd_info: pwd_info
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 修改会员信息
 * @msg:  无
 * @param {*} pwd_info{name,email,wechat,line}
 * @return {*}
 */
 export async function change_user_info(user_info) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'POST',
        url: `${ServerPath}/api/api/change_user_info.html`,
        headers: {
            authorization: `bearer ${token}`
        },
        data: {
            user_info: user_info
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取会员信息
 * @msg:  无
 * @return {*}
 */
export async function user_info() {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/good_select/user_info.html`,
        headers: {
            authorization: token ? `bearer ${token}` : ''
        },
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}